export const EXPIRED_INDICATOR = 'expiredIndicator';

export const EXPIRED_INDICATOR_ACTIONS_NAME = {
  fetchExpiredIndicator: `${EXPIRED_INDICATOR}/fetchExpiredIndicator`,
};

export const EXPIRED_INDICATOR_MUTATIONS_NAME = {
  setHasExpiredIndicator: `${EXPIRED_INDICATOR}/setHasExpiredIndicator`,
};

export const EXPIRED_INDICATOR_GETTERS_NAME = {
  hasExpiredIndicator: `${EXPIRED_INDICATOR}/hasExpiredIndicator`,
};
